// extracted by mini-css-extract-plugin
export default {"modalButtonContainer":"RecentActivities_modalButtonContainer__+b3B3","modalButton":"RecentActivities_modalButton__+SAwy"};